module.exports = __webpack_public_path__ + "img/147ne.c65135c0.svg";